export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/6wKRGrrZYn7sz3mz3xVbUX/mockup_shopify.png';

export const testimonials = [
  {
    quote:
      'Organicé el Halloween más épico que tuvimos en casa en un fin de semana. Los chicos no paraban de hablar de la fiesta. Nunca más improvisar globos naranjas de último momento.',
    name: 'Lucía M.',
    city: 'Buenos Aires',
    role: 'Mamá de tres, organizadora de fiestas familiares',
  },
  {
    quote:
      'Los juegos del Tomo 4 salvaron la noche. Cuando los chicos se estaban aburriendo, abrí el PDF y en 5 minutos teníamos a todos gritando y riéndose. Impagable.',
    name: 'Romina G.',
    city: 'Rosario',
    role: 'Mamá que recibe a toda la familia en Halloween',
  },
  {
    quote:
      'El maquillaje de terror fácil fue un golazo. Mi hijo quería ser zombie y yo no sabía ni por dónde empezar. Seguí los pasos y quedó increíble. Me filmaron en el colegio.',
    name: 'Valeria F.',
    city: 'Córdoba',
    role: 'Mamá primeriza en fiestas de Halloween',
  },
];

export const pains = [
  { title: 'Llegás al 31 de octubre sin nada planificado', text: 'Sin decoración, sin disfraz, sin juegos. Todo a último momento.' },
  { title: 'La fiesta se apaga a los 20 minutos', text: 'Los chicos se aburren y no sabés cómo mantener la energía del evento.' },
  { title: 'Decoraciones que no impactan', text: 'Globos naranjas y telarañas de cotillón que no generan el ambiente que querés.' },
  { title: 'Disfraces carísimos que duran una noche', text: 'Sin ideas para hacer algo casero, original y que realmente sorprenda.' },
  { title: 'La mesa dulce siempre igual', text: 'Gomitas y chocolates en un plato. Sin presentación, sin temática, sin magia.' },
  { title: 'No sabés cómo entretener a distintas edades', text: 'Los más chicos se aburren con lo de los grandes y viceversa.' },
  { title: 'Maquillaje que no te sale', text: 'Ves tutoriales en YouTube y nunca te queda como en el video.' },
  { title: 'Cada año empezás de cero', text: 'Sin un sistema que te resuelva Halloween de una vez y para siempre.' },
];

export const audience = [
  {
    title: 'Mamás organizadoras de fiestas',
    text: 'Que reciben chicos en casa y quieren que cada momento de la noche tenga magia, susto y diversión garantizada.',
    isNew: false,
  },
  {
    title: 'Todo con lo que tenés en casa',
    text: 'Materiales de librería, ropa vieja y lo que conseguís en cualquier negocio de cotillón argentino. Sin importaciones ni gastos innecesarios.',
    isNew: false,
  },
  {
    title: 'Para todas las edades en la misma fiesta',
    text: 'Juegos, historias y actividades pensadas para que chicos de 4 años y adolescentes de 15 disfruten la misma noche sin que nadie se aburra.',
    isNew: true,
  },
  {
    title: 'Buscás el ambiente perfecto de terror',
    text: 'Vas por la decoración que impacta al abrir la puerta, el disfraz casero que gana el concurso y el maquillaje que asusta de verdad.',
    isNew: false,
  },
];

export const topics = [
  'Decoración', 'Disfraces', 'Juegos', 'Mesa dulce', 'Maquillaje', 'Leyendas',
  'Trivia', 'Bebidas', 'Cine argentino', 'Terror familiar', 'Historias',
];

export const included = [
  'Decoración casera', 'Disfraces DIY', 'Mesa dulce terrorífica', 'Juegos para todas las edades',
  'Maquillaje paso a paso', 'Leyendas argentinas de terror', 'Trivia de 100+ preguntas',
  'Noche de misterio', 'Bebidas y tragos temáticos', 'Cine de terror argentino',
  'Historias para leer a oscuras',
];

export const tomos = [
  {
    code: 'T1',
    title: 'Ideas de Decoración Casera Que Impacta',
    tagline: 'El ambiente que impresiona desde que abren la puerta',
    text: 'Transformá tu casa en una mansión del terror con materiales simples y económicos. Guías paso a paso para que cada rincón tenga su propia historia de miedo — sin gastar una fortuna.',
    bullets: [
      'Decoraciones con materiales de librería y cotillón',
      'Ideas por zona: entrada, living, mesa y jardín',
      'Listas de materiales con precios accesibles en Argentina',
    ],
    featured: false,
  },
  {
    code: 'T2',
    title: 'Ideas de Disfraces Caseros',
    tagline: 'El disfraz que gana el concurso sin costar una fortuna',
    text: 'Disfraces originales, terroríficos y creativos hechos con ropa que ya tenés en casa. Con guías de armado paso a paso para chicos de todas las edades y adultos.',
    bullets: [],
    featured: false,
  },
  {
    code: 'T3',
    title: 'Mesa Dulce y Golosinas Terroríficas',
    tagline: 'La mesa que los chicos no pueden dejar de mirar',
    text: 'Golosinas decoradas, mesa dulce temática y bocaditos de terror que parecen de pastelería profesional. Con guía completa de armado y presentación para que quede perfecta.',
    bullets: [],
    featured: false,
  },
  {
    code: 'T4',
    title: 'Juegos de Halloween Para Que el Evento No Se Apague Nunca',
    tagline: 'La diversión garantizada de principio a fin de la noche',
    text: 'El tomo más importante de la noche. Juegos grupales, dinámicas y actividades pensadas para mantener la energía al máximo en cada momento de la fiesta — para chicos de todas las edades.',
    bullets: [
      'Juegos para chicos de 4 a 15 años',
      'Dinámicas grupales para familias y adultos',
      'Actividades de cierre para el momento más épico de la noche',
    ],
    featured: true,
  },
  {
    code: 'T5',
    title: 'Leyendas Argentinas de Terror',
    tagline: 'Las historias que hacen que nadie quiera apagar la luz',
    text: 'Las leyendas urbanas y relatos de terror más famosos de Argentina, adaptadas para contar en voz alta en la fiesta. Para que el miedo sea parte central de la experiencia — y no solo la decoración.',
    bullets: [],
    featured: false,
  },
  {
    code: 'T6',
    title: 'Maquillaje de Terror Fácil',
    tagline: 'El maquillaje que asusta de verdad, sin ser maquilladora profesional',
    text: 'Guías paso a paso con fotos de cada etapa para lograr los maquillajes de terror más impactantes usando productos que conseguís en cualquier farmacia o perfumería argentina.',
    bullets: [],
    featured: false,
  },
];

export const extras = [
  {
    code: 'Extra 1',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c2c40a33-8f1f-414c-81a9-ef460a0503fd.jpg',
    imageAlt: 'Calabaza iluminada junto a cartas de preguntas de trivia',
    zoom: true,
    title: 'Trivia de Terror — Más de 100 Preguntas Para Todas las Edades',
    text: 'Más de 100 preguntas de trivia de Halloween organizadas por nivel de dificultad — para chicos, adolescentes y adultos. El juego que mantiene a todos en la mesa durante horas.',
  },
  {
    code: 'Extra 2',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5c56bd9a-c84b-4fda-b299-996dc92b54f0.jpg',
    imageAlt: 'Casona antigua bajo la luna con un collar de piedra roja',
    zoom: false,
    title: 'Noche de Misterio — El Collar de la Casona',
    text: 'Una aventura de misterio interactiva completa para jugar en grupo durante la fiesta. Con personajes, pistas y un final sorpresa que nadie va a adivinar. La actividad más recordada de la noche.',
  },
  {
    code: 'Extra 3',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/750fad29-529e-442d-a417-52afd2c12819.jpg',
    imageAlt: 'Poción verde y trago rojo de Halloween junto a velas',
    zoom: false,
    title: 'Bebidas y Tragos de Halloween',
    text: 'Tragos temáticos sin alcohol y con versión para adultos para ambientar cada momento de la noche. Desde la bienvenida hasta el brindis del terror de medianoche.',
  },
];

export const comparison = [
  { without: 'Horas buscando ideas en Pinterest que nunca quedan igual', with: 'Decoraciones paso a paso con materiales argentinos disponibles hoy' },
  { without: 'La fiesta se apaga a los 20 minutos', with: 'Juegos y dinámicas para mantener la energía toda la noche' },
  { without: 'Disfraces carísimos de cotillón que duran una noche', with: 'Disfraces caseros originales con ropa que ya tenés' },
  { without: 'Mesa dulce sin temática ni presentación', with: 'Guía completa de mesa dulce terrorífica paso a paso' },
  { without: 'Maquillaje que no te sale siguiendo videos de YouTube', with: 'Paso a paso con fotos para cada etapa del maquillaje' },
  { without: 'Cada año empezás de cero desde el 1 de octubre', with: 'Un sistema completo que resuelve tu Halloween para siempre' },
  { without: 'Los chicos de distintas edades no se divierten igual', with: 'Juegos y actividades para todas las edades en la misma noche' },
  { without: 'Sin historias ni ambiente de terror real', with: 'Leyendas argentinas y noche de misterio interactiva incluidas' },
];

export const premiumTomos = [
  {
    code: 'TP1',
    title: 'Cine de Terror Argentino',
    text: 'La guía completa del terror hecho en Argentina para ver en familia durante Halloween. Con reseñas, curiosidades, ranking por edad y la selección perfecta para cada momento de la noche — desde las películas para los más chicos hasta las que no dejan dormir a los grandes.',
  },
  {
    code: 'TP2',
    title: 'Historias Para Leer a Oscuras',
    text: 'Una colección de historias de terror originales pensadas para leer en voz alta durante la fiesta, con las luces apagadas y una linterna. Escalofriantes, argentinas y graduadas por nivel de susto — para que cada integrante de la familia viva su propio momento de terror genuino.',
  },
];

export const faqs = [
  { q: '¿Cómo recibo el Megapack después de comprar?', a: 'Al confirmar el pago recibís acceso inmediato por email con el link de descarga de todos los tomos y extras en formato PDF. En menos de 5 minutos ya lo tenés en tu teléfono o computadora.' },
  { q: '¿Sirve si nunca organicé una fiesta de Halloween?', a: 'Sí, completamente. Los 6 tomos principales están diseñados para que cualquier mamá pueda seguirlos paso a paso sin experiencia previa. Cada idea tiene materiales, tiempos y guías visuales para que salga perfecto.' },
  { q: '¿Los materiales se consiguen en Argentina?', a: 'Sí. Todo está pensado con materiales de librerías, cotillones y farmacias argentinas. Sin productos importados ni difíciles de conseguir.' },
  { q: '¿Los 3 extras están incluidos en las dos ofertas?', a: 'Sí. La Trivia, la Noche de Misterio y las Bebidas están incluidas tanto en el Megapack Base como en el Premium sin costo adicional.' },
  { q: '¿Sirve para chicos de todas las edades?', a: 'Sí. Los juegos, actividades e historias están graduados por edad para que chicos de 4 años y adolescentes de 15 disfruten la misma noche sin que nadie se aburra.' },
  { q: '¿Qué diferencia tiene con ideas gratis de Pinterest o Instagram?', a: 'Las ideas de redes no están adaptadas a materiales argentinos, no tienen guías de coordinación de la noche completa ni actividades para mantener la energía durante horas. El Megapack está diseñado para que planifiques toda la noche de principio a fin, no solo una decoración suelta.' },
  { q: '¿Para qué edad son las Historias Para Leer a Oscuras del Premium?', a: 'Las historias están graduadas por nivel de susto — desde versiones para chicos de 6 años hasta historias que no dejan dormir a los adultos. Hay algo para cada integrante de la familia.' },
  { q: '¿Por qué elegir el Premium y no el Base?', a: 'El Premium agrega el Cine de Terror Argentino y las Historias Para Leer a Oscuras — dos experiencias que transforman una fiesta de Halloween en un evento cultural completo que la familia va a recordar por años.' },
  { q: '¿Tiene garantía real?', a: 'Sí. 7 días completos desde la compra. Si no quedás satisfecha, te devolvemos el 100% del dinero sin preguntas ni formularios.' },
];
